import React, { useEffect } from 'react';
import '../CSS/About.css';
import { Link } from 'react-router-dom';

const HIGHLIGHTS = [
  { icon: 'fas fa-award', title: '22+ Years', desc: 'Over two decades of excellence in education since our founding in 2003 by Mr. Rahul Singh.' },
  { icon: 'fas fa-user-graduate', title: '500+ Students Annually', desc: 'From 12 students at inception to hundreds each year — our growth reflects our commitment.' },
  { icon: 'fas fa-school', title: '2 Branches', desc: 'Century Branch and Khemani Branch serve Marathi, English medium, Science and Commerce streams.' },
  { icon: 'fas fa-chalkboard-teacher', title: '30+ Educators', desc: 'A dedicated team of subject-matter experts providing personalised guidance to every student.' },
  { icon: 'fas fa-book', title: 'Curated Material', desc: 'In-house study notes, question banks, and mock tests aligned with the latest Maharashtra and CBSE syllabi.' },
  { icon: 'fas fa-compass', title: 'Career Counselling', desc: 'Free one-on-one sessions to help students choose the right stream, college, and career path.' },
];

const About = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <>
      {/* Page Banner */}
      <div className="ngt-page-banner">
        <h1>About Nalanda Group Tuitions</h1>
        <p>21+ Years of Nurturing Academic Excellence in Ulhasnagar, Maharashtra</p>
      </div>

      {/* Breadcrumb */}
      <nav aria-label="breadcrumb" className="container mt-3">
        <ol className="breadcrumb" style={{ fontSize: '0.85rem' }}>
          <li className="breadcrumb-item"><a href="/">Home</a></li>
          <li className="breadcrumb-item active">About Us</li>
        </ol>
      </nav>

      {/* Intro + Quote */}
      <section className="ngt-about-intro">
        <div className="container">
          <div className="row g-5 align-items-center">
            <div className="col-lg-5">
              <div id="aboutCarousel" className="carousel slide" data-bs-ride="carousel">
                <div className="carousel-inner">
                  {[require('../assets/award3.jpg'), require('../assets/award4.jpg'), require('../assets/award_receiving.jpg')].map((img, i) => (
                    <div key={i} className={`carousel-item${i === 0 ? ' active' : ''}`} data-bs-interval="4000">
                      <img src={img} className="d-block w-100" alt={`NGT Award ${i + 1}`} style={{ borderRadius: '8px', maxHeight: '360px', objectFit: 'cover' }} loading="lazy" />
                    </div>
                  ))}
                </div>
                <button className="carousel-control-prev" type="button" data-bs-target="#aboutCarousel" data-bs-slide="prev">
                  <span className="carousel-control-prev-icon"></span>
                  <span className="visually-hidden">Previous</span>
                </button>
                <button className="carousel-control-next" type="button" data-bs-target="#aboutCarousel" data-bs-slide="next">
                  <span className="carousel-control-next-icon"></span>
                  <span className="visually-hidden">Next</span>
                </button>
              </div>
            </div>
            <div className="col-lg-7">
              <h2 className="section-title text-start mb-4" style={{ textAlign: 'left' }}>
                About NGT
              </h2>
              <p style={{ fontSize: '1.05rem', marginBottom: '1.5rem' }}>
                Nalanda Group Tuitions (NGT), founded by <strong>Mr. Rahul Singh</strong>, has over <strong>21 years</strong> of
                excellence in providing quality education. With a team of 30+ experienced educators, NGT focuses on
                personalised instruction, well-curated study materials, and career counselling.
              </p>
              <p style={{ marginBottom: '1.5rem' }}>
                NGT coaches students for prestigious examinations including <strong>IIT-JEE, NEET, AIIMS, IISER, MH-CET</strong>, and
                more. Our mission is to make a meaningful difference in the way students think, approach challenges,
                and prepare for the competitive world.
              </p>
              <blockquote>
                "At NGT, we believe in nurturing young minds with quality education and unwavering support to pave the way for a brighter future."
                <cite>— Mr. Rahul Singh, Founder, Nalanda Group Tuitions</cite>
              </blockquote>
              <div className="mt-4">
                <Link to="/enquiry" className="btn-ngt-primary me-3">Enquire Now</Link>
                <Link to="/faculty" className="btn-ngt-outline">Meet Our Faculty</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Highlights */}
      <section className="ngt-highlights" aria-labelledby="highlights-heading">
        <div className="container">
          <h2 className="section-title" id="highlights-heading">Highlights</h2>
          <p className="section-subtitle">What sets Nalanda Group Tuitions apart</p>
          <div className="row g-4">
            {HIGHLIGHTS.map((h, i) => (
              <div key={i} className="col-md-6 col-lg-4">
                <div className="ngt-highlight-card h-100">
                  <div className="hi-icon"><i className={h.icon}></i></div>
                  <h4>{h.title}</h4>
                  <p>{h.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Mission */}
      <section className="ngt-about-mission">
        <div className="container text-center">
          <h2>Our Mission &amp; Vision</h2>
          <hr style={{ borderColor: 'var(--ngt-gold)', width: '60px', borderWidth: '3px', margin: '1rem auto 2rem' }} />
          <div className="row g-4 justify-content-center">
            <div className="col-md-5">
              <h5 style={{ color: 'var(--ngt-gold)', marginBottom: '0.8rem' }}>Mission</h5>
              <p>
                To provide every student with accessible, high-quality coaching that bridges the gap between
                classroom learning and competitive excellence — empowering them to achieve their highest potential.
              </p>
            </div>
            <div className="col-md-5">
              <h5 style={{ color: 'var(--ngt-gold)', marginBottom: '0.8rem' }}>Vision</h5>
              <p>
                To be the most trusted educational partner for students and families in Ulhasnagar and beyond,
                shaping future leaders through disciplined learning, mentorship, and values-based education.
              </p>
            </div>
          </div>
          <div className="mt-4">
            <Link to="/enquiry" className="btn-ngt-gold" style={{ padding: '12px 32px', fontSize: '1rem' }}>
              Begin Your Journey Today
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
